import { put, select } from 'redux-saga/effects';

import * as actions from '../../actions';

import deleteQuestionChoice from './deleteQuestionChoice';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);

  if (surveysState.activeFlow && !surveysState.activeFlow.flows) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api('updateQuestion', newSurveyStateActiveFlow);
  }

  const newState = deleteQuestionChoice(
    surveysState,
    action.flowId,
    action.choiceId
  );

  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });
}
